module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-600.4a5aff1.woff";